export const DATA_TABLE_GUTTER_CLASS = "pl-4";
